import { useSelector } from 'react-redux'
import featureToggles from 'shared/featureToggles'
import { userAccountIdSelector } from 'auth/selectors'

export const getRwgToken = () => {
    const queryParams = new URLSearchParams(window.location.search)
    const token = queryParams.get('rwg_token')

    return token
}

const removeRwgTokenParam = () => {
    const url = new URL(window.location)
    const params = new URLSearchParams(url.search)

    params.forEach((value, key) => {
        if (key.includes('rwg_token')) {
            params.delete(key)
        }
    })

    url.search = params.toString()
    window.history.replaceState({}, document.title, url.toString())
}

export const setGoogleReserveCookiesFromUrl = locationId => {
    const tokenCookie = `_rwg_token=${getRwgToken()}; max-age=2592000; domain=${window.location.hostname}; path=/`
    const merchantIdCookie = `_merchant_id=${locationId}; max-age=2592000; domain=${window.location.hostname}; path=/`
    document.cookie = tokenCookie
    document.cookie = merchantIdCookie

    removeRwgTokenParam()
}

export const sendGTAGEvent = (eventName, params, userId) => {
    if (window?.gtag) {
        if (userId) {
            params.user_id = userId
        }
        window.gtag('event', eventName, params)
    }
}

export const useSendGTAGEvent = () => {
    const userAccountId = useSelector(userAccountIdSelector)

    return (eventName, params, userId = userAccountId) => {
        sendGTAGEvent(eventName, params, userId)
    }
}
